import { gql, useMutation } from '@apollo/client';
import { patchPageEditorAfterSave } from './pageEditorCache';
import { PAGE_SLOT_FIELDS } from './pageEditorGraphql';

const useUpdatePage = () => {
  const [__updatePage] = useMutation(UPDATEPAGE, {
    update(cache, { data }, { variables }) {
      if (data?.updatePage && variables?.id) {
        patchPageEditorAfterSave(cache, variables.id, data.updatePage);
      }
    },
  });

  const updatePage = (id, page, eventType) => __updatePage({
    variables: { id, page, eventType },
    // A manual save is logged; History lists it only when the server's SHOW_DRAFT_SAVES is on (it's off).
    refetchQueries: eventType === 'SAVE_DRAFT' ? ['PageHistory'] : []
  });

  return {
    updatePage
  };
};

/* =============================================================================
=    GraphQL: Mutation
============================================================================= */
const UPDATEPAGE = gql`
mutation updatePage($id: String!, $page: UpdatePageInput, $eventType: String) {
  updatePage(_id: $id, page: $page, eventType: $eventType) {
    _id
    updatedAt
    title
    path
    canonicalRel
    category {
      _id
      title
      path
    }
    template {
      templateId
      version
      props
    }
    metadata
    slots {
      ${PAGE_SLOT_FIELDS}
    }
  }
}
`;

export default useUpdatePage;
